import { OrganizationsCommissions } from 'store/analytics/types';

type CalculateCommissionParams = {
  commission: boolean;
  organizationsCommissions: OrganizationsCommissions;
  organization: string;
};

type CalculateCommissionItemParams = {
  key: string;
  value: string | number;
};

export const calculateCommission =
  ({
    commission,
    organizationsCommissions,
    organization
  }: CalculateCommissionParams) =>
  ({ key, value }: CalculateCommissionItemParams) => {
    const price = Number(value);

    if (!commission || organization === 'all') {
      return price;
    }

    const selectedOrganization = organizationsCommissions[organization];

    if (!selectedOrganization) {
      return price;
    }

    const percent =
      selectedOrganization[key as keyof OrganizationsCommissions[string]];

    if (!percent) {
      return price;
    }

    return price * (percent / 100);
  };
